import { Grid, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import * as roleApi from '../../api/app/roleApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { SelectBoxAutocomplete } from '../../components/core/SelectBox/SelectBoxAutocomplete';
import { SelectBoxAutocompleteAsync } from '../../components/core/SelectBox/SelectBoxAutocompleteAsync';
import { useTranslation } from '../../contexts/translation';
import { PermissionInputs } from '../../types/app/permission.types';
import { Role } from '../../types/app/role.types';
interface Props {
  onSubmit: SubmitHandler<PermissionInputs>;
  defaultValues?: PermissionInputs;
  onBack: any;
}

export function PermissionForm({ onSubmit, defaultValues, onBack }: Props) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm<PermissionInputs>();

  const { data: role, isLoading, isError } = useQuery<Role[]>('role', roleApi.getRoleList);

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues]);

  if (isError) return <ApiError />;
  if (isLoading || !role) return <Loader />;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SelectBoxAutocompleteAsync
              isRequired
              label={t('page.permission.edit-input-label-1')}
              valueKey={'userId'}
              labelKey={'fullName'}
              controllerProps={{
                name: 'userId',
                control: control,
                rules: { required: t('page.permission.validation-required-name') },
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectBoxAutocomplete
              isRequired
              label={t('page.permission.edit-input-label-2')}
              items={role}
              valueKey={'identifier'}
              labelKey={'description'}
              controllerProps={{
                name: 'identifier',
                control: control,
                rules: { required: t('page.permission.validation-required-role') },
              }}
              errors={errors}
            />
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button type="submit" variant="contained" color="primary">
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
